/* eslint-disable react/no-unescaped-entities */
import { Grid } from '@mui/material';
import { Cropper } from 'shell/components/shared/cropper';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { DocumentCivilUnionFormVM } from 'civil-status/view-models/document-birth-form';
import { PageMode } from 'civil-status/view-models/page-mode';
import AnnotationForm from '../shared/annotation';
import UploadFileForm from '../shared/upload-file';
import { StickyDiv } from 'shell/components/shared/sticky-div';
import UnionFormComponent from '../shared/civil-union-form';
interface DocumentCivilUnionFormProps {
  values?: DocumentCivilUnionFormVM;
  errors?: FormikErrors<DocumentCivilUnionFormVM>;
  touched?: FormikTouched<DocumentCivilUnionFormVM>;
  onChange: (
    key: keyof DocumentCivilUnionFormVM,
    value: DocumentCivilUnionFormVM[keyof DocumentCivilUnionFormVM]
  ) => void;
  onChanges: (value: DocumentCivilUnionFormVM) => void;
  mode: PageMode;
  type: string;
  setMode: (mode: PageMode) => void;
}

const DocumentCivilUnionComponent = ({
  values,
  mode,
  type,
  errors,
  touched,
  onChange,
  onChanges,
  setMode,
}: DocumentCivilUnionFormProps): React.ReactElement => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <UploadFileForm values={values} onChange={onChange} mode={mode} />
          {mode === PageMode.Detail || mode === PageMode.Edit ? (
            <UnionFormComponent
              onChange={onChange}
              onChanges={onChanges}
              values={values}
              errors={errors}
              mode={mode}
              touched={touched}
            />
          ) : undefined}
          <AnnotationForm
            values={values}
            onChange={onChange}
            mode={mode}
            type={type}
            setMode={setMode}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <StickyDiv>
            <Cropper
              images={values?.uploadFile?.raw || []}
              disabled={!values?.uploadFile?.raw?.length}
              height={900}
            />
          </StickyDiv>
        </Grid>
      </Grid>
    </>
  );
};

DocumentCivilUnionComponent.displayName = 'Document Civil union form component';

const DocumentCivilUnionForm = memo(DocumentCivilUnionComponent);

export default DocumentCivilUnionForm;
